import MainHeader from './MainHeader.container';

export default MainHeader;
